module.exports = __webpack_public_path__ + "static/media/unloaded_pass.c36701fe.svg";